import React from 'react';
import { Chrome } from './src/components/chrome/chrome';
import { Store, StoreContext } from './src/stores';

export const wrapRootElement = ({ element }) => {
  return (
    <StoreContext.Provider value={Store}>
        <Chrome>{element}</Chrome>
    </StoreContext.Provider>
  );
};